import { BotMutationDefinition } from '@feedyou-ai/feedbot-schema'
import { MUTATION_ID_SEPARATOR } from './constants'

type Item = { mutationIds: string[]; value: string }
type Orders = { [k: string]: number }
type Group = Item[][]

export function getMutationCombinations(mutations: BotMutationDefinition[]) {
  const group: Group = []
  const groups: Group[] = []
  const orders: Orders = {}

  mutations.forEach((mutation, mutationIndex) => {
    const items: Item[] = []
    mutation?.options?.forEach(option => {
      if (!option.id || !mutation.id) {
        return
      }

      orders[option.id] = mutationIndex
      items.push({ mutationIds: [mutation.id], value: option.id })
    })

    group.push(items)
  })

  groups.push(group)
  for (let index = 0; index < mutations.length - 1; index++) {
    const newGroup = getNextGroup(groups[index], mutations, orders, index + 1)
    newGroup.length !== 0 && groups.push(newGroup)
  }

  return groups.map(group => group.map(items => items.map(item => item.value)).flat()).flat()
}

function getNextGroup(
  group: Group,
  mutations: BotMutationDefinition[],
  orders: Orders,
  groupIndex: number
) {
  const memory: string[] = []
  const newGroup: Group = []
  group.forEach(items => {
    items.forEach(item => {
      const newItems: Item[] = []
      mutations.forEach(mutation => {
        if (item.mutationIds.includes(mutation.id)) {
          return
        }

        mutation.options.forEach(option => {
          const newValue = createValue(item.value, option.id, orders, groupIndex)
          if (!newValue || memory.includes(newValue)) {
            return
          }

          memory.push(newValue)
          newItems.push({
            value: newValue,
            mutationIds: item.mutationIds
          })
        })
      })
      newItems.length !== 0 && newGroup.push(newItems)
    })
  })

  return newGroup
}

function createValue(previousValue: string, value: string, orders: Orders, groupIndex: number) {
  const items = previousValue.split(MUTATION_ID_SEPARATOR).reduce((output, mutationId) => {
    const index = orders[mutationId]
    output[index] = mutationId

    return output
  }, [] as string[])

  const index = orders[value]
  items[index] = value

  const validItems = items.filter(item => item)
  return groupIndex === validItems.length - 1 ? validItems.join(MUTATION_ID_SEPARATOR) : undefined
}
